/*
  Lades die van de zijkant openschuiven, voor secties buiten de header.

  De winkelmand en het zoekpaneel hebben hun eigen versie in de header, omdat
  daar meer omheen zit — één paneel tegelijk open, cursor in het zoekveld. Dit
  is de kale variant, en hij bemoeit zich alleen met `details[data-drawer]`,
  zodat de twee elkaar niet in de weg zitten.

  Markup:
    <details data-drawer scroll-lock>
      <summary>...</summary>
      <div data-close data-animated></div>     <- verduistering
      <aside data-animated>... <button data-close> ...</aside>
    </details>
*/
async function closeDrawer(drawer) {
  if (!drawer.open || drawer.hasAttribute('data-closing')) return;

  drawer.setAttribute('data-closing', '');

  /*
    De lopende animaties uitlezen in plaats van een vaste vertraging: gaat de
    duur in CSS omhoog of omlaag, dan volgt dit vanzelf. Staan er geen
    animaties — bij prefers-reduced-motion — dan is de lijst leeg en sluit de
    lade meteen.
  */
  const animations = Array.from(drawer.querySelectorAll('[data-animated]')).flatMap((element) =>
    element.getAnimations ? element.getAnimations() : []
  );

  await Promise.allSettled(animations.map((animation) => animation.finished));

  drawer.open = false;
  drawer.removeAttribute('data-closing');
}

document.addEventListener('click', (event) => {
  /*
    Ook de eigen knop onderscheppen: klik je die aan terwijl de lade openstaat,
    dan klapt hij zonder dit meteen dicht en zie je de uitgaande animatie niet.
  */
  const summary = event.target.closest('[data-drawer] > summary');
  if (summary && summary.parentElement.open) {
    event.preventDefault();
    closeDrawer(summary.parentElement);
    return;
  }

  const closer = event.target.closest('[data-drawer] [data-close]');
  if (closer) closeDrawer(closer.closest('[data-drawer]'));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-drawer][open]').forEach(closeDrawer);
});
